<template>
    <div>
        5555
    </div>
</template>

<script>
  export default {
    name: "withdrawal"
  }
</script>

<style scoped>

</style>